import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function AcceptdComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('acceptd')} />
}
